import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { ProvPayerService } from '../../services/prov-payer.service';
import { forkJoin } from 'rxjs';
import { ValidationMsgs } from 'src/app/core/Constants/static';
import { InputDatepicker } from 'src/app/shared/components/datepicker_v2/interfaces/input-datepicker';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.css']
})
export class CompanyDetailsComponent implements OnInit {
  showDetails: boolean = true;
  @Input() formGroupName!: string;
  @Input() submitted: boolean = false;
  @Input('uniQueId') uniQueId: any = 1;
  @Input() isEdit : boolean =false;
  @Output('isThirdPartyComp') isThirdPartyComp: EventEmitter<any> = new EventEmitter();
  @Input('isThirdPartyComp') thirdPartyTrue = false;
  companyDetailsForm!: FormGroup;
  currencyList: any[] = [];
  countryList: any[] = [];
  isThirdParty: boolean = false;
  validationMsg = ValidationMsgs.datePattern;
  EndDateError = ValidationMsgs.EndDateError;
  startDateError = ValidationMsgs.startDateError;
  @ViewChild('focusElement') focusElement!: ElementRef;
  constructor(
    private rootFormGroup: FormGroupDirective,
    private provPayerApiService: ProvPayerApiService,
    private proPayerService: ProvPayerService

  ) {
  }
  feild_startDate = {
    type: 'datetimepicker',
    inputClassName: ["form-control date-input"],
    selectedDateClassName: ['selectedDate', 'form-control'],
    arrowClassName: ['arrow'],
    dayClassName: ['dd'],
    todayClassName: ['now'],
    monthClassName: ['mtn'],
    monthListClassName: ['monthlist'],
    yearBtnHeadClassName: ['YY'],
    yearListClassName: ['yList'],
    range: true,
    locale: 'en-IN',
    placeholder: 'DD/MM/YYYY',
    options: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    classname: ['form-control'],
  };
  validity_date_v2:InputDatepicker={
    type: 'datepicker_v2',
    name: 'Validity',
    range: true,
    locale: 'en-IN',
    required : true,
    inputClassName:'form-control date-input',
    selectedDateClassName: 'selectedDate',
    arrowClassName: 'arrow',
    dayClassName: 'dd',
    todayClassName: 'now',
    monthClassName: 'mtn',
    datepickerHeaderClass:'', //classes for the active date div
    headerButtonClass:'', // classes for month-year buttons
    yearClassName:'',
    options: {year: 'numeric', month: '2-digit', day: '2-digit'},
    classname: '',
    timer:false,
    disabled:false, // disables the datepicker
    seperator:' to ', // seperator b/w dates
    startDatePlaceHolder:'DD/MM/YYYY',
    dateFormat:'DD/MM/YYYY' ,// dd-mm-yyyy | dd/mm/yyyy
    dateSeperator:'/', // seperator b/w dd,mm,yyyy
  }
  ngOnInit(): void {

    this.proPayerService.isThirdParyOpened$.subscribe(val => {
      this.isThirdParty = val;
    })

    this.getMasterLists();
    this.companyDetailsForm = this.rootFormGroup?.control.get(
      this.formGroupName
    ) as FormGroup;

  }
  ngAfterViewInit(){
     setTimeout(() => {
       document.getElementById('companyName1'+this.uniQueId)?.focus();
     },500);
  }
  getMasterLists() {
    forkJoin([
      this.provPayerApiService.getCurrencyList(),
      this.provPayerApiService.getCountryList(),
    ]).subscribe({
      next: (responseList) => {
        this.currencyList = responseList[0];
        this.countryList = responseList[1];
      }
    })
  }
  isThirdPartyCompany() {
    this.isThirdPartyComp.emit(this.isThirdParty);
  }
}


